import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface InfoDialogData {
  message: string;
}

@Component({
  template: `
    <div class="flex gap-4 p-2">
      <i class="pi pi-info-circle text-3xl" style="color: var(--p-primary-500); flex-shrink: 0; margin-top: 2px;"></i>
      <div class="text-base leading-relaxed" [innerHTML]="data.message"></div>
    </div>
    <div class="flex justify-end mt-4 pt-3" style="border-top: 1px solid var(--p-surface-200);">
      <button (click)="close()" pButton type="button" class="p-button-raised">Got it</button>
    </div>
  `,
  standalone: false,
})
export class InfoDialogComponent {
  data: InfoDialogData;

  constructor(dialogConfig: DynamicDialogConfig<InfoDialogData>, private ref: DynamicDialogRef) {
    this.data = dialogConfig.data || { message: '' };
  }

  close() {
    this.ref.close(true);
  }
}
